const imageStatus = (condition) => {
	return condition() ? 'on' : 'off';
};

const gameCategoryUtils = { imageStatus };

export default gameCategoryUtils;
